const theme = {
  fonts: {
    main: "'Hind', sans-serif",
  },
  colors: {
    primary: '#8E56A6', // kursifant lila hell
    secondary: '#f2bb16', // kursifant yellow
    hoverButtonBackground: '#8E56A6', // kursifant lila hell
    success: '#2cb228',
    danger: '#F23535', // kursifant rot
  },
};

export default theme;
